(function () {
    'use strict';

    angular
        .module('loyalty')
        .controller('LoyaltyProgramItemController', LoyaltyProgramItemController);
    LoyaltyProgramItemController.$inject = ['LoyaltyService', '$uibModal'];
    function LoyaltyProgramItemController(LoyaltyService, $uibModal) {
        var vm = this;
        vm.flag = false;
        vm.activate = activate;
        vm.getProgramItems = getProgramItems;
        vm.getProgramItemsSelect = getProgramItemsSelect;
        vm.serviceSelected = -1;
        vm.serviceStatus = [{id : -1, name : '--- All ---'},{id : 1, name : 'Yes'}, {id : 0, name : 'No'}];
        vm.serviceStatusSelected = -1;
        vm.deleteProgramItem = deleteProgramItem;
        vm.createProgramItem = createProgramItem;
        vm.editProgramItem = editProgramItem;
        vm.services = [];

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getProgramItems();
        }

        function getProgramItemsSelect()
        {
            LoyaltyService.getProgramItemsForSelect().then(function(response) {
                vm.servicesSelect = response.data;
                vm.servicesSelect.unshift({id: - 1, description: '--- All ---'});
            });
        }

        function getProgramItems()
        {
            vm.flag = false;
            vm.query = {};
            if(vm.serviceSelected !== -1) {
                vm.query['service'] = vm.serviceSelected;
            }
            if(vm.serviceStatusSelected !== -1) {
                vm.query['status'] = vm.serviceStatusSelected;
            }
            vm.query['page'] = vm.page;
            LoyaltyService.getProgramItems(vm.query).then(function(response) {
                vm.flag = true;
                vm.services = response.data.data;
                vm.totalItems = response.data.total;
                vm.to         = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function deleteProgramItem(item)
        {
            alertify
                .confirm('Do you really delete ' + item.description + '?')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Alert!')
                .set('onok', function (){
                    vm.query = {};
                    vm.query['id']  = item.id;
                    LoyaltyService.deleteProgramItem(vm.query).then(function(response) {
                        vm.services.splice(vm.services.indexOf(item), 1);

                        alertify.notify('Service item successfully deleted!', 'success', 3);
                    }).catch(function(err) {
                    });
                })
                .show();
        }

        function createProgramItem()
        {
            $uibModal.open({
                templateUrl: 'templates/loyalty/reports/serviceItems/create/create.modal.html',
                controller: 'LoyaltyProgramItemCreateController',
                controllerAs:'loyaltyProgramItemCreate',
                resolve: {
                    programItems : function () {
                        return vm.services;
                    },
                    totalItems : function () {
                        return vm.totalItems;
                    },
                    to : function () {
                        return vm.to;
                    },
                }
            });
        }

        function editProgramItem(item)
        {
            $uibModal.open({
                templateUrl: 'templates/loyalty/reports/serviceItems/edit/edit.modal.html',
                controller: 'LoyaltyProgramItemEditController',
                controllerAs:'loyaltyProgramItemEdit',
                resolve: {
                    item : function () {
                        return item;
                    }
                }
            });
        }

        function activate()
        {
            vm.getProgramItemsSelect();
            vm.getProgramItems();
        }

        vm.activate();
    }
})();